// Central image-quality policy for next/image.
//
// HARD CONSTRAINT: every value here MUST be a member of the `qualities`
// allowlist in next.config.mjs. Next.js 16 returns HTTP 400 from the image
// optimizer for any `quality` prop that is not in that list - there is no
// silent clamp.
//
// 2026-05-31 perf+bugfix: DealCard and VoucherListClient shipped a quality
// prop of 90, which is NOT in `qualities: [60, 75]`. Verified against
// the live prod optimizer that `/_next/image?...&q=90` returns HTTP 400
// (q=60 -> 3.3 KB, q=75 -> 5.6 KB, q=90 -> 400) on a real card image, so
// every grid/list card thumbnail would 400 the moment that code deploys.
// Centralised here and locked by scripts/lcp-payload-optimizations.test.mjs
// (tree-wide quality-allowlist scan) so the quality props and the
// next.config allowlist can never drift apart again.
//
// If you add a new quality tier: add it to next.config `qualities` FIRST,
// then reference it here.

// Grid / list card thumbnails. These are the bulk of image bytes on the
// homepage, category and voucher-list pages (24 imgs ~ 423 KiB on the
// homepage), so the lower of the two allowed tiers is the right default -
// the cards render small and subsampling absorbs the delta.
export const CARD_IMAGE_QUALITY = 60;
